(function () {
  const heroes = Array.from(document.querySelectorAll('[data-pc-hero]'));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function initHero(hero) {
    const canvas = hero.querySelector('[data-pc-hero-canvas]');
    const stage = hero.querySelector('[data-hero-stage]');
    const enableCanvas = hero.getAttribute('data-enable-3d') === 'true';
    const mobileLite = hero.getAttribute('data-mobile-performance') === 'true' && window.innerWidth < 760;
    const intensity = clamp(Number(hero.getAttribute('data-intensity') || 55) / 100, 0.2, 1);

    let ctx = null;
    let width = 1;
    let height = 1;
    let dpr = Math.min(window.devicePixelRatio || 1, 2);
    let particles = [];
    let raf = 0;
    let visible = false;
    const mouse = { x: 0.64, y: 0.44, tx: 0.64, ty: 0.44 };

    function progress() {
      const rect = hero.getBoundingClientRect();
      return clamp((window.innerHeight - rect.top) / (window.innerHeight + rect.height * 0.45), 0, 1);
    }

    function applyProgress() {
      const p = reducedMotion ? 1 : progress();
      hero.style.setProperty('--hero-progress', p.toFixed(3));
      hero.classList.toggle('is-assembled', p > 0.62);
      hero.classList.toggle('is-powered', p > 0.82);
      return p;
    }

    function resize() {
      const rect = hero.getBoundingClientRect();
      width = Math.max(1, rect.width);
      height = Math.max(1, rect.height);
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      if (canvas && ctx) {
        canvas.width = Math.floor(width * dpr);
        canvas.height = Math.floor(height * dpr);
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      makeParticles();
      applyProgress();
    }

    function makeParticles() {
      const count = reducedMotion ? 0 : Math.round((mobileLite ? 34 : 76) * intensity);
      particles = Array.from({ length: count }, (_, index) => ({
        x: width * (0.42 + Math.random() * 0.56),
        y: height * (0.12 + Math.random() * 0.78),
        vx: (Math.random() - 0.5) * 0.12,
        vy: (Math.random() - 0.5) * 0.12,
        r: Math.random() * 1.4 + 0.35,
        hue: index % 5 === 0 ? 38 : index % 4 === 0 ? 265 : 188,
        phase: Math.random() * Math.PI * 2
      }));
    }

    function draw(time) {
      raf = 0;
      const p = applyProgress();
      mouse.x += (mouse.tx - mouse.x) * 0.07;
      mouse.y += (mouse.ty - mouse.y) * 0.07;

      if (stage && !reducedMotion && window.innerWidth > 989) {
        const rx = (mouse.y - 0.5) * -5;
        const ry = (mouse.x - 0.5) * 8 - 8;
        stage.style.transform = `rotateY(${ry.toFixed(2)}deg) rotateX(${rx.toFixed(2)}deg) translate3d(${((mouse.x - 0.5) * 10).toFixed(1)}px, ${((mouse.y - 0.5) * 8).toFixed(1)}px, 0)`;
      }

      if (ctx) {
        ctx.clearRect(0, 0, width, height);
        const join = clamp((p - 0.1) / 0.52, 0, 1);
        const mx = mouse.x * width;
        const my = mouse.y * height;

        particles.forEach((particle, index) => {
          const anchorX = width * (0.58 + (index % 9) * 0.035);
          const anchorY = height * (0.22 + ((index * 7) % 19) * 0.027);
          particle.x += particle.vx + (anchorX - particle.x) * 0.0025 * join;
          particle.y += particle.vy + (anchorY - particle.y) * 0.0025 * join;

          const dx = particle.x - mx;
          const dy = particle.y - my;
          const dist = Math.max(42, Math.hypot(dx, dy));
          if (dist < 150) {
            particle.x += (dx / dist) * 0.36;
            particle.y += (dy / dist) * 0.36;
          }

          if (particle.x < width * 0.36) particle.x = width * 0.98;
          if (particle.x > width + 12) particle.x = width * 0.42;
          if (particle.y < -12) particle.y = height + 12;
          if (particle.y > height + 12) particle.y = -12;

          const alpha = 0.16 + Math.sin(time * 0.0015 + particle.phase) * 0.08;
          ctx.beginPath();
          ctx.fillStyle = `hsla(${particle.hue}, 100%, 64%, ${alpha})`;
          ctx.arc(particle.x, particle.y, particle.r, 0, Math.PI * 2);
          ctx.fill();

          if (join > 0.2 && index % 4 === 0) {
            const next = particles[(index + 6) % particles.length];
            const distance = Math.hypot(next.x - particle.x, next.y - particle.y);
            if (distance < 120) {
              ctx.beginPath();
              ctx.strokeStyle = `rgba(38, 244, 255, ${0.045 * join})`;
              ctx.lineWidth = 1;
              ctx.moveTo(particle.x, particle.y);
              ctx.lineTo(next.x, next.y);
              ctx.stroke();
            }
          }
        });
      }

      if (visible && !reducedMotion) raf = requestAnimationFrame(draw);
    }

    function requestDraw() {
      if (!raf && visible && !reducedMotion) raf = requestAnimationFrame(draw);
    }

    if (enableCanvas && canvas && !reducedMotion) {
      ctx = canvas.getContext('2d', { alpha: true });
      if (!ctx) hero.classList.add('is-fallback');
    }

    hero.addEventListener('pointermove', (event) => {
      const rect = hero.getBoundingClientRect();
      mouse.tx = clamp((event.clientX - rect.left) / rect.width, 0, 1);
      mouse.ty = clamp((event.clientY - rect.top) / rect.height, 0, 1);
      requestDraw();
    }, { passive: true });

    window.addEventListener('resize', resize, { passive: true });
    window.addEventListener('scroll', () => {
      applyProgress();
      requestDraw();
    }, { passive: true });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        visible = entry.isIntersecting;
        if (visible) requestDraw();
        if (!visible && raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
      });
    }, { threshold: 0.04 });

    resize();
    hero.classList.add('is-hero-ready');
    observer.observe(hero);
    if (reducedMotion) applyProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => heroes.forEach(initHero));
  } else {
    heroes.forEach(initHero);
  }
})();
